import React from "react";

//todo(jsimms): move to icon assets directory and regenerate using the icon script
export const UGGLogo = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 20 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.226 2.69629V20.7934C13.4201 21.813 11.5263 22.3294 9.59399 22.3294C7.66165 22.3294 5.76832 21.813 3.96244 20.7934V2.69629L0 4.44843V22.967L0.882536 23.5566C3.55705 25.3452 6.56924 26.2902 9.59399 26.2902C12.6187 26.2902 15.6314 25.3452 18.3059 23.5566L19.188 22.967V4.44843L15.226 2.69629Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.49294 0L7.51172 0.876296V13.8423C8.16824 14.0306 8.83014 14.1259 9.49294 14.1259C10.1557 14.1259 10.8176 14.0306 11.4737 13.8423V0.876296L9.49294 0Z"
        fill="#3273FA"
      />
    </svg>
  );
};
